import { combineReducers } from "redux";

import Auth from "./auth/reducer";
import AuthAdmin from "./authAdmin/reducer";

const rootReducer = combineReducers({
  Auth,
  AuthAdmin
});

export default rootReducer;
